module.exports = __webpack_public_path__ + "static/media/CommandQuasi1.ba107010.mp4";